import { render, staticRenderFns } from "./OrgUserAdmin.vue?vue&type=template&id=4f41638c"
import script from "./OrgUserAdmin.vue?vue&type=script&lang=js"
export * from "./OrgUserAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f41638c')) {
      api.createRecord('4f41638c', component.options)
    } else {
      api.reload('4f41638c', component.options)
    }
    module.hot.accept("./OrgUserAdmin.vue?vue&type=template&id=4f41638c", function () {
      api.rerender('4f41638c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/OrgUserAdmin.vue"
export default component.exports